module.exports = __webpack_public_path__ + "img/wallpaper_hero.41809c11.jpg";